import React from 'react';
import Script from 'next/script';
import config from '../../config';

export const GoogleOptimize: React.FC = () =>
    config.gOptimizeContainerId ? (
        <Script id={`google-optimize-${config.gOptimizeContainerId}`} src={`https://www.googleoptimize.com/optimize.js?id=${config.gOptimizeContainerId}`} />
    ) : null;
